const currentChannelIdSelector = state => state.elements.ChannelsPanel.currentId;

export default currentChannelIdSelector;
